//-All SVG icons can be imported section wise here

//----Home Page Icons
import { ReactComponent as RUNNING } from "assets/images/icons/running-vehicle.svg";
import { ReactComponent as STOPPED } from "assets/images/icons/stopped-vehicle.svg";
import { ReactComponent as IDLING } from "assets/images/icons/idling-vehicle.svg";
import { ReactComponent as OFFLINE } from "assets/images/icons/offline-vehicle.svg";
import { ReactComponent as CHARGING } from "assets/images/icons/charging-vehicle.svg";
import { ReactComponent as TOWING } from "assets/images/icons/towing-vehicle.svg";

//----Dashboard Menu Icons
import { ReactComponent as DB_VEHICLE_ANALYTICS } from "assets/images/icons/db-vehicle-analytics.svg";
import { ReactComponent as DB_VEHICLE_HEALTH } from "assets/images/icons/db-vehicle-health.svg";
import { ReactComponent as DB_BATTERY_PERFORMANCE } from "assets/images/icons/db-battery-performance.svg";
import { ReactComponent as DB_FLEET_MONITOR } from "assets/images/icons/db-fleet-monitor.svg";
import { ReactComponent as DB_FLEET_ANALYTICS } from "assets/images/icons/db-fleet-analytics.svg";
import { ReactComponent as DB_EOL_TESTS } from "assets/images/icons/db-eol-tests.svg";
import { ReactComponent as DB_EOL_ANALYTICS } from "assets/images/icons/db-eol-analytics.svg";
import { ReactComponent as DB_TEST_RIDE } from "assets/images/icons/db-test-ride.svg";
import { ReactComponent as DB_TEST_RIDES_COMPARISON } from "assets/images/icons/db-test-rides-comparison.svg";
import { ReactComponent as DB_SPEAK_WITH_DATA } from "assets/images/icons/db-speak-with-data.svg";
import { ReactComponent as DB_COMPETITOR_PULSE } from "assets/images/icons/db-competitor-pulse.svg";

export const DASHBOARD_ICONS = {
    VEHICLE_ANALYTICS: DB_VEHICLE_ANALYTICS,
    VEHICLE_HEALTH: DB_VEHICLE_HEALTH,
    BATTERY_PERFORMANCE: DB_BATTERY_PERFORMANCE,
    FLEET_MONITOR: DB_FLEET_MONITOR,
    FLEET_ANALYTICS: DB_FLEET_ANALYTICS,
    EOL_TESTS: DB_EOL_TESTS,
    EOL_ANALYTICS: DB_EOL_ANALYTICS,
    TEST_RIDE: DB_TEST_RIDE,
    TEST_RIDES_COMPARISON: DB_TEST_RIDES_COMPARISON,
    SPEAK_WITH_DATA: DB_SPEAK_WITH_DATA,
    COMPETITOR_PULSE: DB_COMPETITOR_PULSE,
}

export const VEHICLE_STATUS = {
    RUNNING: RUNNING,
    STOPPED: STOPPED,
    IDLING: IDLING,
    OFFLINE: OFFLINE,
    CHARGING: CHARGING,
    TOWING: TOWING,
}

export { DB_VEHICLE_ANALYTICS };
export { DB_VEHICLE_HEALTH }

